<template>
  <div class="top" :class="siteName">
    <span class="ic">{{title}}</span>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'top',
  data() {
    return {
      siteName: process.env.siteName
    }
  },
  props: {
      title: {
        type: String
      }
  },
  created () {
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.top
  @extend .s-top
  .ic
    height 16px
    background url(ic_6.png) no-repeat left center
    color #626262
    font-size 14px
    line-height 16px
    padding-left 25px
  &.b027site {
    .ic {
      background url(ic_6_b.png) no-repeat left center
    }
  }
  &.b027sport {
    .ic {
      background url(ic_6_green.png) no-repeat left center
    }
  }
  .more
    width 97px
    height 26px
    line-height 26px
    text-align center
    border solid 1px #2d8fea
    border-radius 20px
    color #2d8fea
    font-size 13px
    cursor pointer
  .buy-btn
    @extend .btn
    background #f59c25
  .sell-btn
    @extend .btn
    margin-left 20px
.top {
  &.b027site {
    a.sell-btn {
      background #1c1c1d
    }
  }
  &.b027sport {
    a.sell-btn {
      background #01815e
    }
  }
}
</style>



// WEBPACK FOOTER //
// top.vue?00fe8c5b